module.exports = __webpack_public_path__ + "home-hero@2x-2CD7Q1b.png";